import { Drawer, Divider, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Logo } from '@pinnacleautomotive/clarity-components';
import React from 'react';
import logo from './../../assets/diamonddigital-logo.svg';
import AppMenuAvatar from './AppMenuAvatar';
import AppMenuList from './AppMenuList';

const PREFIX = 'AppMenuDrawer';

const classes = {
  drawer: `${PREFIX}-drawer`,
  drawerPaper: `${PREFIX}-drawerPaper`,
  toolbar: `${PREFIX}-toolbar`,
  menu: `${PREFIX}-menu`,
  menuItem: `${PREFIX}-menuItem`,
  divider: `${PREFIX}-divider`,
};

const StyledDrawer = styled(Drawer)(({ theme, variant }) => ({
  [`&.${classes.drawer}`]: {
    width: drawerWidth,
    flexShrink: 0,

    [theme.breakpoints.down('xl')]: {
      width: variant === 'temporary' ? drawerWidth : '64px',
      zIndex: 1251,
    },
  },

  [`& .${classes.drawerPaper}`]: {
    width: drawerWidth,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.grey[900],

    [theme.breakpoints.only('lg')]: {
      width: variant === 'temporary' ? drawerWidth : '64px',
      overflowX: 'hidden',
    },
  },

  [`& .${classes.toolbar}`]: theme.mixins.toolbar,

  [`& .${classes.menu}`]: {
    height: '100%',
    flexWrap: 'nowrap',
  },

  [`& .${classes.menuItem}`]: {
    width: '100%',
  },

  [`& .${classes.divider}`]: {
    borderColor: '#303030',
  },
}));

const drawerWidth = 240;

const AppMenuDrawer = props => {
  return (
    <StyledDrawer
      className={classes.drawer}
      anchor="left"
      classes={{
        paper: classes.drawerPaper,
      }}
      variant={props.variant}
      open={props.open}
      onClose={props.onClose ? props.onClose : null}
    >
      <div className={classes.toolbar}>
        <Logo width="100%" height="100%" maxWidth="156px" logo={logo} />
      </div>
      <Divider className={classes.divider} />
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
        className={classes.menu}
      >
        <Grid item className={classes.menuItem}>
          <AppMenuList isTemporary={props.variant === 'temporary'} />
        </Grid>
        <Grid item className={classes.menuItem}>
          <AppMenuAvatar isTemporary={props.variant === 'temporary'} />
        </Grid>
      </Grid>
    </StyledDrawer>
  );
};

export default AppMenuDrawer;
